import React, { ReactNode } from 'react'
import { DecoratorNode, DOMExportOutput, LexicalNode, NodeKey, SerializedLexicalNode } from 'lexical'
import { EmbedType, MeetingInfoElement } from '../../../models'
import { EmbeddedMeetingInfo } from '../Embeds/EmbeddedMeetingInfo'

export interface SerializedEmbeddedMeetingInfoNode extends SerializedLexicalNode {
  element: MeetingInfoElement
}

export class EmbeddedMeetingInfoNode extends DecoratorNode<ReactNode> {
  __element: MeetingInfoElement

  static getType(): string {
    return EmbedType.MEETING_INFO
  }

  static clone(node: EmbeddedMeetingInfoNode): EmbeddedMeetingInfoNode {
    return new EmbeddedMeetingInfoNode(node.__element, node.__key)
  }

  constructor(element: MeetingInfoElement, key?: NodeKey) {
    super(key)
    this.__element = element
  }

  createDOM(): HTMLElement {
    return document.createElement('div')
  }

  updateDOM(): false {
    return false
  }

  decorate(): ReactNode {
    return <EmbeddedMeetingInfo element={this.__element} />
  }

  exportJSON(): SerializedEmbeddedMeetingInfoNode {
    return {
      type: EmbedType.MEETING_INFO,
      version: 1,
      element: this.__element,
    }
  }

  static importJSON(_serializedNode: SerializedEmbeddedMeetingInfoNode): EmbeddedMeetingInfoNode {
    return $createEmbeddedMeetingInfoNode(_serializedNode.element)
  }

  exportDOM(): DOMExportOutput {
    return {
      element: document.createTextNode(`@embed(meetingInfo(${JSON.stringify({ displayId: this.__element.displayId })}))`),
    }
  }
}

export const $createEmbeddedMeetingInfoNode = (element: MeetingInfoElement): EmbeddedMeetingInfoNode => new EmbeddedMeetingInfoNode(element)

export const $isEmbeddedMeetingInfoNode = (node: LexicalNode | null | undefined): node is EmbeddedMeetingInfoNode => node instanceof EmbeddedMeetingInfoNode
